import React, { useState, useRef } from "react";
import { UITextInput } from "..";

import "./styles.css";

/**
 * @function UIPhoneNumberInput 
 * @returns {React.Component}
 * @example
 * <UIPhoneNumberInput />
 */
export default function UIPhoneNumberInput(props) {
    // Hooks for reading and limiting the character
    // counts of the phone number inputs.
    const propsHasValue = props.value ?? false;
    let modifiedValue = props.value;
    if(propsHasValue) {
        modifiedValue = props.value.replace(/[^\w\s]/gi, '');
    }

    const stateObj = { 
    firstInputVal: propsHasValue ? modifiedValue.slice(0, 3) : "",
    secondInputVal: propsHasValue ? modifiedValue.slice(3, 6) : "",
    thirdInputVal: propsHasValue ? modifiedValue.slice(6, 10) : ""
    };
    const propsHasOnChange = typeof props.onChange === "function";
    const [inputVal, setInputVal] = useState(stateObj);
    const [ firstInputRef, secondInputRef, thirdInputRef ] = [ useRef(), useRef(), useRef() ];
    const setFocus = inputContainer => inputContainer.getElementsByTagName('input')[0].focus();
    
    const dataPointFirstField = props.dataPoint ? { "dataPoint" : `${ props.dataPoint }_Field_0` } : {};
    const dataPointSecondField = props.dataPoint ? { "dataPoint" : `${ props.dataPoint }_Field_1` } : {};
    const dataPointThirdField = props.dataPoint ? { "dataPoint" : `${ props.dataPoint }_Field_2` } : {};

    // Limit the character count for each input in the phone number inputs.
    const onChange = prop => val => {
        switch(prop) {
            case "firstInputVal":
                if(val.length < 4 && !isNaN(val)) {
                    setInputVal({...inputVal, firstInputVal: val});
                    if(propsHasOnChange) props.onChange({...inputVal, firstInputVal: val});

                    if(val.length === 3) {
                        setFocus(secondInputRef.current);
                    }
                } 
                break;
            case "secondInputVal":
                if(val.length < 4 && !isNaN(val)) {
                    setInputVal({...inputVal, secondInputVal: val});
                    if(propsHasOnChange) props.onChange({...inputVal, secondInputVal: val});

                    if(val.length === 3) {
                        setFocus(thirdInputRef.current);
                    }
                } 
                break;
            case "thirdInputVal":
                if(val.length < 5 && !isNaN(val)) {
                    setInputVal({...inputVal, thirdInputVal: val});
                    if(propsHasOnChange) props.onChange({ ...inputVal, thirdInputVal: val });
                } 
                break;
            default:
                break;
        }
    }
    return (
        <div className="ui-phone-number-input">
            <div className="flex-container flex-horizontal align-center">
                <div ref={ firstInputRef } className="set-width flex-container flex-horizontal align-center">
                    &#40;<UITextInput value={ inputVal.firstInputVal } onChange={ onChange("firstInputVal") } { ...dataPointFirstField } />&#41;
                </div>
                <div ref={ secondInputRef } className="set-width flex-container flex-horizontal align-center">
                    <UITextInput value={ inputVal.secondInputVal } onChange={ onChange("secondInputVal") } { ...dataPointSecondField } />&#8208;
                </div>
                <div ref={ thirdInputRef } className="set-width">
                    <UITextInput value={ inputVal.thirdInputVal } onChange={ onChange("thirdInputVal") } { ...dataPointThirdField } />
                </div>
            </div>
        </div>
    )
}
